import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M4_FloydWarshall = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Floyd-Warshall Algorithm - All Pair Shortest Path"
      videos={["https://www.youtube.com/embed/Gc4mWrmJBsw", "https://www.youtube.com/embed/oNI0rf2P9gE"]}
      takeaways={[
        { text: "Why Floyd-Warshall Algorithm is better for Dense Graphs and not for Sparse Graphs?" },
        { text: "Time and space complexities." },
        { text: "Direct numerical-based questions will be asked, solving the problem itself takes more time." },
      ]}
      questions={[
        "Perform a step-by-step process to find the shortest path distance between every pair of vertices using the Floyd-Warshall algorithm, from the directed weighted graph.",
        "Using the appropriate algorithm, find the shortest path between all pairs.",
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M4_FloydWarshall;
